(() => {
  if (customElements.get('dope-menu-search')) return;
  customElements.define('dope-menu-search', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.addEventListener('click', (event) => {
        const chip = event.target.closest('[data-dope-search-chip]');
        if (!chip || !this.contains(chip)) return;
        const input = this.querySelector('input[type="search"]');
        if (!input || !input.closest('form[is="predictive-search"]')) return;
        event.preventDefault();
        input.value = chip.dataset.dopeSearchChip;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus({ preventScroll: true });
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
})();
